export default __webpack_public_path__ + "newBackground.fad63f2.png";